export default __webpack_public_path__ + "static/logo-804212232f3966b982a2894427d297fb.png";